import { ShuttleFilters } from '../../../domain/shuttle';
import { LocalStorage } from '../../../utils';

const SHUTTLE_FILTERS_KEY = 'shuttle-filters';

// === Shuttle Filters =================================
export const storeShuttleFiltersInLocalStorage = (shuttleFilters: ShuttleFilters) =>
  LocalStorage.setItem(SHUTTLE_FILTERS_KEY, shuttleFilters);

export const getShuttleFiltersFromLocalStorage = (): ShuttleFilters => LocalStorage.getItem(SHUTTLE_FILTERS_KEY);
